/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ScheduledEmailStatus;

(function (ScheduledEmailStatus) {
  ScheduledEmailStatus["INSTANT"] = "instant";
  ScheduledEmailStatus["PENDING"] = "pending";
  ScheduledEmailStatus["IN_PROGRESS"] = "in_progress";
  ScheduledEmailStatus["DONE"] = "done";
  ScheduledEmailStatus["FAILED"] = "failed";
  ScheduledEmailStatus["CANCELLED"] = "cancelled";
})(ScheduledEmailStatus || (ScheduledEmailStatus = {}));